import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import SubHeading from "../Text/SubHeading";
import SmallContainer from "../Container/SmallContainer";

const Slots = ({ dailyData, selectedSlot, setSelectedSlot, selectedDate }) => {
  return (
    <SmallContainer marginTop={"20px"}>
      {!selectedDate ? (
        <SmallContainer marginTop="20px">
          <SubHeading subHeadingLabel="*Please select a Date"></SubHeading>
        </SmallContainer>
      ) : (
        <>
          <Flex width={"23.81%"} marginTop={"18px"}>
            <SubHeading subHeadingLabel="Available Slots" />
          </Flex>
          <SmallContainer marginBottom={"20px"} alignItems={"center"}>
            {dailyData ? (
              dailyData["availableSlots"]?.map(
                (slot, i) =>
                  slot.closed !== true &&
                  dailyData["agentsPerSlot"]?.[slot?.timeSlotId] >
                    dailyData["bookingsPerSlot"]?.[slot?.timeSlotId] && (
                    <SubHeading
                      display={"flex"}
                      justifyContent="center"
                      alignItems={"center"}
                      key={i}
                      backgroundColor={
                        selectedSlot?.slotTime === slot.slotTime
                          ? "#0E3665"
                          : "#ECEFF9"
                      }
                      color={
                        selectedSlot?.slotTime === slot.slotTime
                          ? "#FFFFFF"
                          : "#0E3665"
                      }
                      textColor={
                        selectedSlot?.slotTime === slot.slotTime
                          ? "#FFFFFF"
                          : "#0E3665"
                      }
                      width={"70%"}
                      borderRadius={"100px"}
                      height={"38px"}
                      _hover={{
                        color: "#FFFFFF",
                        backgroundColor: "#0E3665",
                        cursor: "pointer",
                      }}
                      mt={"4"}
                      onClick={() => setSelectedSlot(slot)}
                      subHeadingLabel={slot.slotTime}
                    />
                  )
              )
            ) : (
              <Text>No Slot Available</Text>
            )}
          </SmallContainer>
        </>
      )}
    </SmallContainer>
  );
};

export default Slots;
